var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 57 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6692 0H2.20997C1.1753 0 0.336426 0.881571 0.336426 1.96889C0.336426 3.05621 1.1753 3.93778 2.20997 3.93778H54.6692C55.7038 3.93778 56.5427 3.05621 56.5427 1.96889C56.5427 0.881571 55.7038 0 54.6692 0Z",
    fill: "#EBECEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3327 15.3279H1.87354C0.838879 15.3279 0 16.2095 0 17.2968C0 18.3841 0.838879 19.2657 1.87354 19.2657H54.3327C55.3674 19.2657 56.2063 18.3841 56.2063 17.2968C56.2063 16.2095 55.3674 15.3279 54.3327 15.3279Z",
    fill: "#EBECEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3327 30.675H1.87354C0.838879 30.675 0 31.5557 0 32.6439C0 33.7322 0.838879 34.6128 1.87354 34.6128H54.3327C55.3674 34.6128 56.2063 33.7322 56.2063 32.6439C56.2063 31.5557 55.3674 30.675 54.3327 30.675Z",
    fill: "#EBECEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburg);
export default __webpack_public_path__ + "static/media/hamburg.a9f6c439152de0c71472b2a3665c0e33.svg";
export { ForwardRef as ReactComponent };